import * as React from 'react';
import { clsx } from 'clsx';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера полноэкранного модального окна
 *
 * @export
 * @class ModalFullscreen
 * @extends {React.Component<IModalFullscreenViewProps>}
 */
export function ModalFullscreenView(_ref) {
  let {
    children,
    theme = 'white',
    print = true,
    zIndex
  } = _ref;
  const styles = getStyles(theme);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['fullscreen'], !print && styles['no-print']),
    style: {
      zIndex
    },
    "aria-modal": "true",
    role: "dialog",
    children: children
  });
}